module.exports = __webpack_public_path__ + "img/sacDesktop-en-US.df4d1cc7.png";